// extracted by mini-css-extract-plugin
export var deleteIcon = "_q9-5";
export var deleteOption = "_q9-3";
export var divider = "_q9-2";
export var downloadIcon = "_q9-4";
export var drawer = "_q9-0";
export var drawerFooter = "_q9-6";
export var drawerOpen = "_q9-1";
export var highlighted = "_q9-7";
export var lighterHighlight = "_q9-8";